<template>
  <div
    class="d-flex align-center tabel-line-wrapper"
    :class="[isBottomBorderNotShow ? '' : 'borderBottom']"
  >
    <slot></slot>
  </div>
</template>

<script>
export default {
  props: {
    isBottomBorderNotShow: {
      type: Boolean,
      default: false,
    },
  },
};
</script>

<style lang="scss" scoped>
.tabel-line-wrapper {
  padding: 20px;
}
.borderBottom {
  border-bottom: 1px solid $tableOrderColor;
}
</style>
